import LoginHeader from "./Common/LoginHeader";
import Footer from "./Common/Footer";
// import { Link } from "react-router-dom";
import { Component } from "react";
import * as myConstList from "./Common/BaseUrl";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "moment";
import { ImageValidation } from "./Validation/ImageValidation";
import ExchangeSecondHeader from "./Common/ExchangeSecondHeader";
import DocumentMeta from "react-document-meta";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ProductName } from "./Common/ProductName";

const baseUrl = myConstList.baseUrl;

export class chatting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: "",
      method: "",
      location: "",
      tabledata1: [],
      id: "",
      USER_ID: "",
      tichekId: this.props.match.params.coin,
      respStatus: "",
      ResponceData: "",
      issueImageSecond: "",
      SubSetx: "",
      OpenSteps: "Send_Message",
      OpenStepsAll: "all",
      events: [],
      dateTime: "",
      chatValue: "",
      tabledata: [],
      btnDisable: false,
      query: "",
      queryImage: false,
      queryIssue: "",
      commonDate: "",
      verifyidpic: "./assets/img/support.jpg",
      userUploadImage: "/assets/img/support.jpg",
      issueDateTime: "",
      editorInstance: null,
    };

    this.logEvent = this.logEvent.bind(this);
    this.clearEvents = this.clearEvents.bind(this);

    if (/^-?[\d.]+(?:e-?\d+)?$/.test(this.state.tichekId) == true) {
      var encodes = btoa(this.state.tichekId);
      this.setState(
        {
          decodes: atob(encodes),
        },
        () => {
          this.TicketList();
          this.ticketchat();
        }
      );
      // var decodes = atob(encodes)
      window.location.replace(`Chatting/${encodes}`);
    }
    // var encodes = btoa(this.state.tichekId)
    else {
      this.TicketList();
      this.ticketchat();
    }
  }

  logEvent = (event) => {
    event.timestamp = new Intl.DateTimeFormat("en", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(new Date());

    this.setState({
      events: [event, ...this.state.events],
    });
  };
  clearEvents = () => {
    this.setState({
      events: [],
    });
  };

  ticketchat = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      },
    };

    var decodes = atob(this.state.tichekId);
    var userIdData = { tichekId: decodes };
    if (
      this.props.match.params.status == "1" ||
      this.props.match.params.status == 1
    ) {
      axios
        .post(baseUrl + "/frontapi/seenStatusChange", userIdData, config)
        .then((resp) => {
          var resp = resp.data;
        });
    }

    axios
      .post(baseUrl + "/frontapi/ticket-chat", userIdData, config)
      .then((res) => {
        var resp = res.data;
        if (resp.status === true) {
          this.setState({
            tabledata: resp.data,
            commonDate: resp.data[0].commonDate,
            respStatus: resp.status,
          });
        }

        if (resp.success === true) {
          this.setState({
            respStatus: resp.success,
            username: "",
            email: "",
            password: "",
            cpassword: "",
            check1: "",
            check2: "",
          });
        }
      });
  };

  // GetUserData = () => {
  //   const config = {
  //     headers: {
  //       "content-type": "multipart/form-data",
  //       Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
  //     },
  //   };

  //   axios.post(baseUrl + "/frontapi/UserData", {}, config).then((resp) => {
  //     var resp = resp.data;
  //   });
  // };

  createMarkup = () => {
    return { __html: this.state.query };
  };

  clearEditorValue = () => {
    if (this.state.editorInstance) {
      this.state.editorInstance.setData("");
    }
  };

  chatSubmit = (e) => {
    if (!this.state.query) {
      this.setState({ queryIssue: "Please enter your message" });
      return false;
    }

    let hasLeadingSpace = /^\s/.test(this.state.query);
    let hasTrailingSpace = /\s$/.test(this.state.query);

    if (hasLeadingSpace) {
      this.setState({ queryIssue: "Please enter a valid message" });
      return false;
    }

    if (hasTrailingSpace) {
      this.setState({ queryIssue: "Please enter a valid message" });
      return false;
    }

    let query = { __html: this.state.query };
    let queryImage = e.target.files;

    // if (queryImage == undefined) {
    //   toast.error("Please Select Image");
    //   return false;
    // }

    // if (query === undefined) {
    //   toast.error("Please select Subject.");
    //   return false;
    // }
    var decodes = atob(this.state.tichekId);

    var userIdData = {
      tichekId: decodes,
      query: this.state.query,
    };

    const formData = new FormData();
    formData.append("userId", localStorage.id);
    formData.append("tichekId", decodes);
    formData.append("query", this.state.query);
    formData.append("queryImage", this.state.queryImage);
    formData.append("replyBy", 2);
    for (var pair of formData.entries()) {
    }
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
        "content-type": "multipart/form-data",
      },
    };

    this.setState({ btnDisable: false });
    // setTimeout(function(){
    //   setTimeout(()=>
    //   this.setState({btnDisable:false}),1000)
    // });

    // setTimeout(() => window.location.reload(true), 2000);

    axios
      .post(baseUrl + "/frontapi/chat-insert", formData, config)
      .then((res) => {
        var resp = res.data;
        if (resp.status === true) {
          this.ticketchat();
          this.clearEditorValue();
          this.setState({
            query: "",
            queryImage: false,
            queryIssue: "",
            userUploadImage: false,
          });
          // this.setState({ query: "1234", queryImage: "" });
          toast.success(resp.message);
          return false;
        } else {
          toast.error(resp.message);
        }
      });
  };

  onChangeImage = (e) => {
    e.preventDefault();
    this.setState({ queryImage: false, userUploadImage: false });

    var queryImage = e.target.files[0];
    this.setState({ userUploadImage: URL.createObjectURL(queryImage) });

    let error = ImageValidation("Chatting", queryImage);

    if (error) {
      this.setState({ imageError: error, btnDisable: false });
      return false;
    }
    this.setState({ imageError: "" });

    if (this.state.query.length > 0) {
      this.setState({ btnDisable: true });
    }

    // if (queryImage == false) {
    //   toast.error("Please select image.");
    //   return false;
    // }
    // if (!queryImage.name.match(/\.(jpg|jpeg|png|gif)$/)) {
    //   toast.error("Please select valid image.");
    //   return false;
    // }
    this.setState({
      queryImage: queryImage,
    });
  };

  onChangeIssue = (event) => {
    // var query = editor.getData();
    let { name, value } = event.target;
    if (name === "query") {
      this.setState({
        query: value,
        queryIssue: "",
      });
      if (!value) {
        this.setState({
          queryIssue: "This field is required",
          btnDisable: false,
        });
      } else {
        this.setState({
          query: value,
          queryIssue: "",
          btnDisable: true,
        });
      }
    }
    // if (!query) {
    //   this.setState({
    //     queryIssue: "This field is required",
    //     btnDisable: false,
    //   });
    // } else {
    //   this.setState({
    //     query: query,
    //     queryIssue: "",
    //     btnDisable: true,
    //   });
    // }
  };

  showTableHtml = () => {
    // if (this.state.respStatus === true) {
    var stylediv = "";
    var classThis = this;
    const html = [];
    let dateArray = [];
    if (this.state.tabledata.length > 0) {
      this.state.tabledata.map((value, i) => {
        if (value.queryImage != "") {
          var profilePic = baseUrl + "/static/helpIssue/" + value.queryImage;
        }
        var date = "";

        if (value.replyBy == 1) {
          stylediv = "charting-part left_side_div";
          date = value.updatedAt;
        } else {
          stylediv = "charting-part right_side_div";
          date = value.createdAt;
        }
        let data = Moment(value.createdAt)
          .format("DD-MM-YYYY HH:mm:ss")
          .split(" ")[0];
        date = Moment(date).format("DD-MM-YYYY HH:mm:ss").split(" ");
        html.push(
          <div className={stylediv}>
            <div style={{ textAlign: "center", color: "white" }}>
              {Moment(this.state.dateTime)
                .format("DD-MM-YYYY HH:mm:ss")
                .split(" ")[0] == data ? (
                <></>
              ) : (
                !dateArray.includes(data) && data
              )}
            </div>
            <div className="chatting-inner">
              {value.queryImage != "" &&
                value.queryImage != undefined &&
                value.queryImage != "NULL" && (
                  <div>
                    <a
                      href=""
                      data-toggle="modal"
                      data-target="#supportImageModel"
                      onClick={() => {
                        classThis.setState({ Image: profilePic });
                      }}
                    >
                      <img src={profilePic} alt="" />
                    </a>
                    <div></div>
                  </div>
                )}
              {value.replyBy == 1 ? (
                <div className="msg-outer user-msg">
                  <div>{value.query}</div>
                  <div className="msg-time">{date[1]}</div>
                </div>
              ) : (
                <div className="msg-outer">
                  <div dangerouslySetInnerHTML={{ __html: value.query }} />
                  <div className="msg-time">{date[1]}</div>
                </div>
              )}
            </div>
          </div>
        );
        !dateArray.includes(data) && dateArray.push(data);
      });
    }
    return html;
    // }
  };

  TicketList = (event) => {
    var decodes = atob(this.state.tichekId);

    var userIdData = { ticketId: decodes };

    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      },
    };

    axios
      .post(baseUrl + "/frontapi/helplist-by-user-ticket", userIdData, config)
      .then((resp) => {
        var respNew1 = resp.data;
        this.setState({ resp1: resp.data });
        // this.GetUserData();
        if (respNew1.status === true) {
          this.setState({
            tabledata1: respNew1.data,
            issueText: respNew1.data[0].issueType,
            issueImageSecond: respNew1.data[0].issueImage,
            dateTime: respNew1.data[0].createAt,
            issueDateTime: respNew1.data[0].createAt,
            respStatus1: respNew1.status,
            ResponceData: respNew1.data[0].status,
            SubSetx: respNew1.data[0].issue,
          });
        }
        if (respNew1.data[0].status == 1) {
          this.setState({ OpenSteps: "Chat_panel", OpenStepsAll: false });
        }
      });
  };

  supportImage = () => {};

  // showStatue = () => {
  //   const html1 = []
  //   if (this.state.respStatus1 === true) {
  //     this.state.tabledata1.map(function(value1, j){
  //       html1.push(
  //         <div>
  //         <h5>Subject: {value1.issue}</h5>
  //         <h5>Status: {value1.status == 0 && "Pending"}{" "}{value1.status==1 && "Resolved"}</h5>
  //         </div>
  //       )
  //     })
  //     return html1
  //   }
  // }

  render() {
    const meta = {
      title: `Support-Chat | ${ProductName}  Exchange`,
      description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName}  Exchange.`,
      meta: {
        charset: "utf-8",
        name: {
          keywords: `${ProductName}  Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
        },
      },
    };
    let { OpenSteps, OpenStepsAll, tabledata } = this.state;

    return (
      <DocumentMeta {...meta}>
        <div>
          <LoginHeader />
          <div className="new_inpage">
            <div className="container container2">
              <div className="profile_left_box bg_light">
                <h4 className="mb-2">Chatting</h4>
                <div className="subject-status-outer d-flex flex-wrap justify-content-between row">
                  <h6 className="col-sm-6">Subject: {this.state.SubSetx}</h6>
                  <h6 className="status-outer col-sm-6 text-sm-right">
                    Status :{" "}
                    {this.state.ResponceData == 0 ? (
                      <i
                        className="fa fa-clock-o"
                        aria-hidden="true"
                        style={{ color: "red" }}
                      >
                        {this.state.ResponceData == 0 && "Pending"}
                      </i>
                    ) : (
                      <i
                        className="fa fa-check-circle-o"
                        style={{ color: "green" }}
                        aria-hidden="green"
                      >
                        Resolved
                      </i>
                    )}{" "}
                  </h6>
                </div>

                <div className="row">
                  {OpenSteps == "Chat_panel" || OpenStepsAll == "all" ? (
                    <>
                      <div className="col-md-6">
                        {this.state.tabledata1.length != 0 && (
                          <div className="bg_white22 chating-outer">
                            {/* <div style={{ textAlign: "center" }}>
                              {
                                Moment(this.state.dateTime)
                                  .format("DD-MM-YYYY HH:mm:ss")
                                  .split(" ")[0]
                                //  .format("LTS")
                              }
                            </div> */}
                            <div className="left_chat_scrool">
                              <div className="charting-part right_side_div">
                                <div
                                  style={{
                                    textAlign: "center",
                                    color: "white",
                                  }}
                                >
                                  {
                                    Moment(this.state.dateTime)
                                      .format("DD-MM-YYYY HH:mm:ss")
                                      .split(" ")[0]
                                    //  .format("LTS")
                                  }
                                </div>

                                {/* <div
                                  style={{
                                    textAlign: "center",
                                    color: "white",
                                  }}
                                >
                                  {Moment(this.state.dateTime)
                                    .format("DD-MM-YYYY HH:mm:ss")
                                    .split(" ")[0] == Moment(value.createdAt)
                                    .format("DD-MM-YYYY HH:mm:ss")
                                    .split(" ")[0] ? (
                                    <></>
                                  ) : (
                                    !dateArray.includes(Moment(value.createdAt)
                                    .format("DD-MM-YYYY HH:mm:ss")
                                    .split(" ")[0]) && Moment(value.createdAt)
                                    .format("DD-MM-YYYY HH:mm:ss")
                                    .split(" ")[0]
                                  )}
                                </div> */}

                                <div className="chatting-inner">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.issueText,
                                    }}
                                  />

                                  {this.state.issueImageSecond != "" &&
                                    this.state.issueImageSecond != undefined &&
                                    this.state.issueImageSecond != "NULL" && (
                                      <div className="msg-outer image-msg user-img-msg">
                                        <a
                                          href="#e"
                                          data-toggle="modal"
                                          data-target="#supportImageModel"
                                          onClick={() => {
                                            this.setState({
                                              Image:
                                                baseUrl +
                                                "/static/helpIssue/" +
                                                this.state.issueImageSecond,
                                            });
                                          }}
                                        >
                                          <img
                                            src={
                                              baseUrl +
                                              "/static/helpIssue/" +
                                              this.state.issueImageSecond
                                            }
                                            alt=""
                                          />
                                        </a>
                                      </div>
                                    )}
                                  <div className="msg-time">
                                    {
                                      Moment(this.state.dateTime)
                                        .format("YYYY-MM-DD HH:mm:ss")
                                        .split(" ")[1]
                                    }
                                  </div>
                                </div>
                              </div>
                              {this.showTableHtml()}

                              <div className=""></div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {OpenSteps == "Send_Message" || OpenStepsAll == "all" ? (
                    <>
                      <div className="col-md-6">
                        <div className="bg_white22  chating-outer">
                          <h5 className="mb-3">Send Your Message Form Here:</h5>
                          {/* <input
                            type="text"
                            className="form-control"
                            name="query"
                            value={this.state.query}
                            onChange={this.onChangeIssue}
                          /> */}
                          <textarea
                            name="query"
                            value={this.state.query}
                            onChange={this.onChangeIssue}
                            className="form-control form_control_textarea"
                            placeholder="Enter Message"
                            id="query"
                          />
                          {/* <CKEditor
                            editor={ClassicEditor}
                            dangerouslySetInnerHTML={this.createMarkup}
                            name="query"
                            value={this.state.query}
                            onChange={this.onChangeIssue}
                            placeholder="Enter Message"
                            className="form-control form_control_textarea"
                            onReady={(editor) => {
                              this.setState({ editorInstance: editor });
                            }}
                            // data={this.state.onChangIssue}
                            // onBlur={this.handleOnBlurMessage.bind(this)}
                          /> */}
                          <p style={{ color: "red" }}>
                            {this.state.queryIssue}
                          </p>
                          {/* try new */}
                          <div className="form-group">
                            <div className=" col-md-6">
                              <label className="fw-500">Attachment</label>

                              <div className="uploader">
                                <input
                                  className="profile_input"
                                  type="file"
                                  id="file-upload"
                                  name="queryImage"
                                  accept="image/*"
                                  onChange={this.onChangeImage}
                                />
                                <label for="file-upload" id="file-drag">
                                  <img
                                    src={
                                      this.state.userUploadImage !== false
                                        ? this.state.userUploadImage
                                        : this.state.verifyidpic
                                    }
                                    className="img-fluid22 support-img"
                                    alt="Identity"
                                  />
                                  <div id="start">
                                    <span className="fasi"></span>
                                    <div>Upload image</div>
                                    <div id="notimage" className="hidden">
                                      Please select an image
                                    </div>
                                  </div>
                                  <div id="response" className="hidden">
                                    <div id="messages"></div>
                                    <progress
                                      className="progress"
                                      id="file-progress"
                                      value="0"
                                    >
                                      <span>0</span>%
                                    </progress>
                                  </div>
                                </label>

                                <p style={{ color: "red" }}>
                                  {this.state.imageError}
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* end new */}
                          <div className="tr">
                            <button
                              onClick={this.chatSubmit}
                              className="btn btn_man  w100px"
                              disabled={
                                !this.state.btnDisable ? "disabled" : ""
                              }
                            >
                              Submit
                            </button>
                          </div>{" "}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div
                    className="modal fade supportImageModel"
                    id="supportImageModel"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-body p-0">
                          <img
                            class="w100"
                            src={this.state.Image}
                            alt="noimg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
          
        </div>
      </DocumentMeta>
    );
  }
}

export default chatting;
